import { Outlet } from "react-router";

function BlankLayout() {
    return (
        <Outlet />
    );
}

export default BlankLayout;